module.exports = __webpack_public_path__ + "static/see-the-person-6b83c46d71f52eb95f987eab7e0d325d.png";